import React, { useEffect, useMemo } from "react"
import { MdOutlineViewKanban, MdViewList } from "react-icons/md"
import { HiViewBoards } from "react-icons/hi"
import { Button, ButtonLoader, ButtonReloadPage } from "../../components/Button"
import { CheckBox, Input, Label, SelectInput } from "../../components/Form"
import UserList from "../../components/UserList"
import TagContainer from "../../container/TagContainer"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import {
  applyFilterList,
  activityOptions,
  activityTimeOptions,
} from "../../core/utils/farmerFilter/filters"
import Kanban from "../../components/ReactTrello/Board"
import { IoFilterOutline } from "react-icons/io5"
import { ActionsButtons } from "../../components/ActionsButtons"
import CsvReader from "../../components/CSVIds"
import { FarmerImportContainer } from "../../container/FarmerImportContainer"
import { CiFilter } from "react-icons/ci"
import { isMobile } from "react-device-detect"
import ActionTableContainer from "../../components/ActionTable"
import { DatePicker, PickerWithType } from "../../components/DatePicker"

const renderSelectInput = ({
  handleChange,
  defaultValue,
  resetFields,
  name,
  options,
  control,
  isDisabled,
  isMulti = false,
  isSearchable = true,
  isClearable = true,
  closeMenuOnSelect = true,
  isOverModal = true,
  menuShouldBlockScroll = true,
  isVirtualized = false
}) => {
  return (
    <SelectInput
      handleChange={handleChange}
      value={defaultValue}
      closeMenuOnSelect={closeMenuOnSelect}
      isSearchable={isSearchable}
      isClearable={isClearable}
      resetFields={resetFields}
      isMulti={isMulti}
      name={name}
      options={options}
      control={control}
      isOverModal={isOverModal}
      menuShouldBlockScroll={menuShouldBlockScroll}
      isVirtualized={isVirtualized}
      isDisabled={isDisabled}
    />
  )
}

export const FilterModalContent = ({
  modalIsOpen,
  setModalIsOpen,
  filter,
  tagsOptions,
  tagException,
  cityOptions,
  activityTimeOptions,
  onChangeFilter,
  control,
  register,
  formsByProject,
  steps,
  groups,
  groupQuestions,
  handleApplyFilter,
  isFilterLoading,
  clearFields,
  resetFields,
  handleTagsToFilter,
  tagsToFilter,
  showKanban,
  isFarmerProfile = true,
  showTagsException = true,
  handleQuestionsWithoutAnswerDateFilter,
  questionsWithoutAnswersDateFilter,
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen} width={500}>
      <ModalHeader closeModal={() => setModalIsOpen(false)} title="Filtro" />
      <ModalBody className="producer-filter">
        <div className="content-filter-modal-farmer">
          <div className="filter-input-select">
            <div className="toggle-label-tags">
              <Label label="Tags" />
              {filter?.tag && filter?.tag?.length > 1 && !filter?.tagException?.length && (
                <CheckBox
                  className="check-date"
                  label="Ao menos uma das tags"
                  onChange={handleTagsToFilter}
                  value="tagsToFilter"
                  checked={tagsToFilter}
                />
              )}
            </div>
            {renderSelectInput({
              handleChange: onChangeFilter("tag"),
              defaultValue: filter?.tag,
              resetFields,
              name: "tag",
              options: tagsOptions,
              control,
              isMulti: true,
              isVirtualized: true,
            })}

            {(isFarmerProfile || showTagsException) && (
              <>
                <Label label="Selecionar produtores sem a(s) tag(s):" />
                {renderSelectInput({
                  handleChange: onChangeFilter("tagException"),
                  defaultValue: filter?.tagException,
                  resetFields,
                  name: "tagException",
                  options: tagException,
                  control,
                  isMulti: true,
                  isVirtualized: true,
                })}
              </>
            )}

            {isFarmerProfile && (
              <>
                {showKanban && (
                  <>
                    <Label label="Data de Atribuição" />
                    <Input
                      type="date"
                      register={
                        typeof register === "function" &&
                        register("date", {
                          onChange: (e) => onChangeFilter("date", e.target.value),
                        })
                      }
                      value={filter?.date || ""}
                    />
                  </>
                )}

                <Label label="Cidade" />
                {renderSelectInput({
                  handleChange: onChangeFilter("city"),
                  defaultValue: filter?.city,
                  resetFields,
                  name: "city",
                  options: [...cityOptions, { value: Math.random(), label: "Não cadastrada" }],
                  control,
                })}

                <Label label="Formulário" />
                {renderSelectInput({
                  handleChange: onChangeFilter("form"),
                  defaultValue: filter?.form || "",
                  resetFields,
                  name: "form",
                  options: formsByProject
                    ? formsByProject.map((item) => ({
                      value: item.id,
                      label: item.title,
                    }))
                    : [],
                  control,
                })}

                <Label label="Etapa" />
                {renderSelectInput({
                  handleChange: onChangeFilter("step"),
                  defaultValue: filter?.step || "",
                  resetFields: resetFields || (!filter.form || !filter.form?.value),
                  name: "step",
                  options: steps || [],
                  control,
                })}

                <Label label="Grupo" />
                {renderSelectInput({
                  handleChange: onChangeFilter("group"),
                  defaultValue: filter?.group || "",
                  resetFields: resetFields || (!filter.form?.value || !filter.step?.value),
                  name: "group",
                  options: groups || [],
                  control,
                  //isDisabled: !filter?.step,
                })}

                <Label label="Questão" />
                {renderSelectInput({
                  handleChange: onChangeFilter("groupQuestions"),
                  defaultValue: filter?.groupQuestions || "",
                  resetFields: resetFields || !filter.form || !filter.step || !filter.group,
                  name: "groupQuestions",
                  options: groupQuestions || [],
                  control,
                })}

                <>
                  <Label label="Data" />
                  <PickerWithType
                    onChange={handleQuestionsWithoutAnswerDateFilter}
                    value={filter?.date || ""}
                    defaultValue={filter?.date || ""}
                    isWhite={false}
                  />
                  <Label label="Retornar produtores sem resposta?" />
                  {renderSelectInput({
                    handleChange: onChangeFilter("producersWithoutDW"),
                    resetFields:
                      resetFields ||
                      !filter?.form ||
                      !filter?.form?.value ||
                      !filter.producersWithoutDW,
                    name: "producersWithoutDW",
                    options: [
                      { value: true, label: "Sim" },
                      { value: false, label: "Não" },
                    ],
                    control,
                    defaultValue: filter?.producersWithoutDW || "",
                  })}
                </>
              </>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter styles={{ justifyContent: "flex-end" }}>
        <Button
          className="button-engagement"
          label="Limpar Filtros"
          variant="outline"
          handleClick={clearFields}
          color="orange"
        />
        {(isFarmerProfile || showTagsException) && (
          <ButtonLoader
            className="button-engagement"
            color="orange"
            handleClick={handleApplyFilter}
            label="Confirmar"
            loading={isFilterLoading}
          />
        )}
      </ModalFooter>
    </ModalPanel>
  )
}

export const EditCityAndStateModal = ({
  modalIsOpen,
  register,
  watch,
  onChangeEditCityAndState,
  editCityAndStateValues,
  handleCloseEditCityAndState,
  handleUpdateUser,
  updatingUser
}) => {
  return (
    <ModalPanel modalIsOpen={modalIsOpen} width={500}>
      <ModalHeader closeModal={handleCloseEditCityAndState} title="Editar" />
      <ModalBody className="producer-filter">
        <div className="content-filter-modal-farmer">
          <div className="filter-input-select">
            <Label label={`${editCityAndStateValues?.field === 'state' ? "Estado" : "Cidade"}`} />
            <Input
              register={
                typeof register === "function" &&
                register("location", {
                  onChange: (e) => onChangeEditCityAndState("location", e.target.value),
                })
              }
              value={watch("location") || ""}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter styles={{ justifyContent: "flex-end" }}>
        <Button
          className="button-engagement"
          label="Cancelar"
          variant="outline"
          handleClick={handleCloseEditCityAndState}
          color="orange"
        />
        <ButtonLoader
          className="button-engagement"
          color="orange"
          handleClick={handleUpdateUser}
          label="Confirmar"
          messageProcess="Salvando..."
          loading={updatingUser}
        />
      </ModalFooter>
    </ModalPanel>
  )
}

const FarmerScreen = ({
  setFilter,
  filter,
  users,
  tagsProject,
  showKanban,
  setShowKanban,
  selectedsUsers,
  isLoading,
  updatingUser,
  isInitialLoading,
  kanbanData,
  onDragEnd,
  onDataChange,
  selectedCardOnBoard,
  handleSelectedCardOnBoard,
  handleSelectedAllCardsOnBoard,
  isCheckAll,
  closeModal,
  lastUpdated,
  reload,
  refresh,
  isFetching,
  isRefetching,
  isFetched,
  handleRemoveTag,
  handleSelectedList,
  control,
  register,
  watch,
  onChangeFilter,
  openModalFilter,
  setOpenModalFilter,
  clearValues,
  isUserAdmin,
  formsByProject,
  steps,
  groups,
  groupQuestions,
  handleApplyFilter,
  isFilterLoading,
  clearFields,
  resetFields,
  setKanbanData,
  setFilteredItens,
  handleTagsToFilter,
  tagsToFilter,
  usersScreen,
  reloadData,
  handleDeleteBeneficiary,
  handleDeleteManyBeneficiaries,
  openEditCityAndState = () => { },
  setOpenEditModal,
  openEditModal,
  onChangeEditCityAndState,
  editCityAndStateValues,
  handleCloseEditCityAndState,
  handleUpdateUser,
  handleNavigateToProfile = () => { },
  handleQuestionsWithoutAnswerDateFilter,
  questionsWithoutAnswersDateFilter,
  applyFilterListMemo,
  kanbanDataByTags,
  setKanbanForTags,
  kanbanForTags,
}) => {
  const cityOptions =
    (users &&
      users?.length &&
      [...new Map(users?.map((item) => [item["city"], item])).values()]
        .filter((item) => item?.city !== null)
        .map(({ city, id }, index) => ({ value: id + index, label: city }))) ||
    []

  const countUsers =
    selectedsUsers && selectedsUsers?.length > 0 ? `(${selectedsUsers?.length})` : ""

  useEffect(() => {
    const farmHeader = document.querySelector(".header-nav")

    if (farmHeader && isMobile) {
      farmHeader.style.display = "none"
    }
  }, [])

  const tagsException = useMemo(() => {
    let tags = (tagsProject || [])?.map(({ id, name }) => ({ value: id, label: name }))

    if (filter?.tag?.length) {
      tags = tags?.filter(
        (obj) =>
          !filter?.tag?.some(
            (criteria) => criteria.value === obj.value && criteria.label === obj.label,
          ),
      )
    }

    return tags
  }, [tagsProject, filter])

  const tagsOptions =
    tagsProject &&
    tagsProject?.map(({ id, name }) => ({
      value: id,
      label: name,
    }))

  return (
    <div className="farmer-screen">
      {isMobile ? (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
          }}>
          <h1>Beneficiários ({users?.length})</h1>
          {isMobile ? <FarmerImportContainer reloadData={reloadData} /> : <></>}
        </div>
      ) : (
        <></>
      )}
      <div
        className={
          isMobile
            ? "users-farmer-screen-filter-buttons farmer-screen-filter-buttons"
            : "farmer-screen-filter-buttons"
        }>
        {isMobile ? (
          <></>
        ) : (
          <div className="input-select">
            <>
              <Input
                placeholder={"Pesquise pelo nome, email ou telefone"}
                onChange={(e) => setFilter({ ...filter, search: e.target.value })}
                value={filter?.search || ""}
                hasIcon={<i class="fi fi-rr-search"></i>}
                isWhite
                hasFocus={false}
              />
            </>
          </div>
        )}
        <div className="buttons">
          {isMobile ? (
            <></>
          ) : (
            <>
              <FarmerImportContainer reloadData={reloadData} />
            </>
          )}
          {isMobile ? (
            <ButtonReloadPage {...{ isFetching, lastUpdated, reload, refresh, usersScreen }} />
          ) : (
            <>
              {/* <CsvReader handleSelectedList={handleSelectedList} users={users} /> */}
              <ActionsButtons
                {...{
                  countUsers,
                  isUserAdmin,
                  selectedsUsers,
                  selectedCardOnBoard,
                  handleDeleteManyBeneficiaries
                }}
              />
            </>
          )}
          {isMobile ? (
            <>
              <TagContainer users={selectedsUsers} />
              <Button
                hiddenText
                hasIcon={showKanban ? <MdViewList size={16} /> : <HiViewBoards size={16} />}
                label={showKanban ? "Lista" : "Kanban"}
                handleClick={() => setShowKanban((show) => !show)}
                color={isMobile ? "new_green" : "orange"}
              />
            </>
          ) : (
            <>
              <Button
                hiddenText
                hasIcon={showKanban ? <MdViewList size={16} /> : <HiViewBoards size={16} />}
                label={showKanban ? "Lista" : "Kanban"}
                handleClick={() => setShowKanban((show) => !show)}
                color={isMobile ? "new_green" : "orange"}
              />
              <TagContainer users={selectedsUsers} />
              {/* <ActionTableContainer
                users={
                  selectedsUsers?.length > 0
                    ? selectedsUsers
                    : applyFilterListMemo
                }
              /> */}
            </>
          )}
          {isMobile ? (
            <></>
          ) : (
            <div
              className="content-page-screen__filter-modal"
              onClick={() => setOpenModalFilter(true)}>
              <>
                <IoFilterOutline className="icon-filter" />
                <text className="text-filter">Filtrar</text>
              </>
            </div>
          )}
        </div>
      </div>
      {isMobile ? (
        <div className="input-select">
          <>
            <Input
              placeholder={"Pesquise pelo nome, email ou telefone"}
              onChange={(e) => setFilter({ ...filter, search: e.target.value })}
              value={filter?.search || ""}
              hasIcon={<i class="fi fi-rr-search"></i>}
              isWhite
              hasFocus={false}
            />
            <div
              className="content-page-screen__filter-modal"
              onClick={() => setOpenModalFilter(true)}>
              <CiFilter fontSize="14" className="icon-filter" color="#0c7349" />
            </div>
          </>
        </div>
      ) : (
        <></>
      )}
      {isMobile ? (
        <></>
      ) : (
        <div style={{display: "flex", justifyContent: !showKanban ? "flex-end" : "space-between", alignItems: "center", marginTop: !showKanban ? "22px" : "16px"}}>
          {showKanban ? <div>
            <Button
              hasIcon={<MdOutlineViewKanban size={16} />}
              label={kanbanForTags ? "Organizar por Status" : "Organizar por Tags"}
              handleClick={() => setKanbanForTags((show) => !show)}
              color={isMobile ? "new_green" : "orange"}
            />
          </div> : <></>}
          <div className="reload-button-date">
            <span>Total de Beneficiários: {users?.length} |</span>
            <ButtonReloadPage {...{ isFetching, lastUpdated, reload, refresh }} />
          </div>
        </div>
      )}
      {showKanban ? (
        <div className="kanban-content">
          <Kanban
            {...{
              kanbanData: kanbanForTags ? kanbanDataByTags : kanbanData,
              setKanbanData,
              filter,
              tagsToFilter,
              handleSelectedAllCardsOnBoard,
              isCheckAll,
              selectedCardOnBoard: selectedsUsers,
              selectedsUsers,
              handleSelectedCardOnBoard,
              users,
              handleRemoveTag,
              onDragEnd,
              onDataChange,
              isLoading,
              isInitialLoading,
              isFetching,
              setFilteredItens,
              handleNavigateToProfile,
            }}
          />
        </div>
      ) : (
        isFetched && (
          <UserList
            loading={isLoading || isFetching || isRefetching || isInitialLoading}
            data={applyFilterListMemo}
            handleRemoveTag={handleRemoveTag}
            openEditCityAndState={openEditCityAndState}
            onSelect={handleSelectedList}
            selecteds={selectedsUsers}
            handleDeleteBeneficiary={handleDeleteBeneficiary}
            handleNavigateToProfile={handleNavigateToProfile}
          />
        )
      )}
      {isMobile ? (
        <ActionsButtons {...{ countUsers, isUserAdmin, selectedsUsers, selectedCardOnBoard }} />
      ) : (
        <></>
      )}
      <FilterModalContent
        {...{
          modalIsOpen: openModalFilter,
          setModalIsOpen: setOpenModalFilter,
          filter,
          tagsOptions,
          tagException: tagsException,
          cityOptions,
          activityOptions,
          activityTimeOptions,
          onChangeFilter,
          control,
          register,
          clearValues,
          formsByProject,
          steps,
          groups,
          groupQuestions,
          handleApplyFilter,
          isFilterLoading,
          clearFields,
          resetFields,
          handleTagsToFilter,
          tagsToFilter,
          showKanban,
          handleQuestionsWithoutAnswerDateFilter,
          questionsWithoutAnswersDateFilter
        }}
      />
      {openEditModal && (
        <EditCityAndStateModal
          {...{
            modalIsOpen: openEditModal,
            setModalIsOpen: setOpenEditModal,
            onChangeEditCityAndState,
            editCityAndStateValues,
            register,
            watch,
            handleCloseEditCityAndState,
            handleUpdateUser,
            updatingUser,
          }}
        />
      )}
    </div>
  )
}

export default FarmerScreen
